import { FC, PropsWithChildren } from 'react';
import { StyledHeader } from '../styles';

export const Section: FC<PropsWithChildren<{ title: string }>> = ({
  title,
  children,
}) => {
  return (
    <>
      <StyledHeader type="subheader">{title}</StyledHeader>
      {children}
    </>
  );
};
